import * as _ from 'lodash'
import {
    IConnection,
    IDimensionSelector,
    IDimensionSelectorSet, IReportTile, IWorkspaceElement, IWorkspaceElementMessage, IWorkspaceElementPost,
    IWorkspaceReport
} from "../PA.Reporting.Core/PA.Reporting.IF";
import {WorkspaceBO} from "./WorkspaceBO";
import {WB_WorkspaceReportDimensionRow, WB_WorkspaceReportRow} from "../PA.Core/PAdbSchemaRows";
import {WorkspaceBOIWorkspaceReportDimensionSelector} from "./WorkspaceBO.IWorkspaceReport.DimensionSelector";
import {IWorkspaceElementRender} from "../PA.UIM.Reporting/PA.UIM.Reporting.IF";
import {JSONUtils} from "../PA.Core/Basic/JSON";
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {ASync} from "../PA.Core/Basic/ASync";

export class WorkspaceBOIWorkspaceReport
    implements IWorkspaceReport,
        IWorkspaceElement {
    WorkspaceBO: WorkspaceBO
    WorkspaceReportRow: WB_WorkspaceReportRow
    _OnInboxMessage: BehaviorSubject<IWorkspaceElementPost>;
    _OnOutboxMessage: BehaviorSubject<IWorkspaceElementPost>;


    constructor(aWorkspaceBO: WorkspaceBO, aWorkspaceReport: WB_WorkspaceReportRow) {
        this.WorkspaceBO = aWorkspaceBO
        this.WorkspaceReportRow = aWorkspaceReport
        this._OnInboxMessage = new BehaviorSubject<IWorkspaceElementPost>(undefined)
        this._OnOutboxMessage = new BehaviorSubject<IWorkspaceElementPost>(undefined)
        this.IReport_init()
    }

    //<editor-fold desc="IWorkspace Element operations">

    private _elementRenderer: IWorkspaceElementRender


    get ElementId(): string | number {
        return this.WorkspaceReportRow.cif.WB_WORKSPACE_RPTL_ID
    }

    get ElementTypeId(): string {
        return this.WorkspaceReportRow.WB_ReportRow.cif.REPORT_TYPE_ID
    }

    get ElementName(): string {
        // We could make this more interesting
        return this.WorkspaceReportRow.WB_ReportRow.cif.REPORT_NAME
    }

    get ElementRenderer(): IWorkspaceElementRender {
        return this._elementRenderer
    }

    get ElementRendererFactoryName(): string {
        let type =this.WorkspaceReportRow.WB_ReportRow.cif.REPORT_TYPE_ID
        if (type.toLowerCase().indexOf("tableau_v")>=0)
            type="Tableau"
        return type + 'ReportRenderer'
    }

    setElementRenderer(aRenderer: IWorkspaceElementRender): void {
        this._elementRenderer = aRenderer
    }

    get ElementRenderOptions(): { [id: string]: any } {
        return JSONUtils.parse(this.WorkspaceReportRow.cif.RENDER_OPTIONS, {})
    }

    get OnInboxMessage(): BehaviorSubject<IWorkspaceElementPost> {
        return this._OnInboxMessage
    }

    get OnOutboxMessage(): BehaviorSubject<IWorkspaceElementPost> {
        return this._OnOutboxMessage
    }

    PostInboxMessage(aMessage: IWorkspaceElementMessage): void {

        if (!_.isEmpty(aMessage)) {
            if (typeof aMessage == "object") {
                if ('SAVE' in aMessage) {
                    this.saveState()
                }
            }
        }

        this._OnInboxMessage.next({WorkspaceElement: this, Message: aMessage})
    }

    PostOutboxMessage(aMessage: IWorkspaceElementMessage): void {
        this._OnOutboxMessage.next({WorkspaceElement: this, Message: aMessage})
    }

    copy(): void {

    }


    //</editor-fold>

    //<editor-fold desc="IReport operations">

    ReportDimensionSet: IDimensionSelectorSet
    _bIDimensionSelectorSetLoaded: boolean
    _IDimensionSelectorLoadPromise: Promise<IDimensionSelectorSet> = undefined

    private IReport_init() {
        const self = this
        this._bIDimensionSelectorSetLoaded = false

        this.ReportDimensionSet = {
            DimensionSelectors: [],
            get bIDimensionSelectorSetLoaded(): boolean {
                return self._bIDimensionSelectorSetLoaded
            },
            get OnIDimensionSelectorSetLoadComplete(): Promise<IDimensionSelectorSet> {
                const selfDSS = this
                if (this.bIDimensionSelectorSetLoaded) {
                    return ASync.resolve(selfDSS)
                }

                if (!_.isUndefined(self._IDimensionSelectorLoadPromise)) {
                    return self._IDimensionSelectorLoadPromise
                }

                self._IDimensionSelectorLoadPromise = new Promise<IDimensionSelectorSet>((resolve, error) => {
                    _.forEach(self.WorkspaceReportRow.WB_WorkspaceReportDimensionRows, (aRptDimRow: WB_WorkspaceReportDimensionRow) => {
                        let parentDimRow = _.first(_.filter(self.WorkspaceBO.DimensionSelectors, aDim => aDim.Dimension.DimensionId === aRptDimRow.WB_DimensionRow.cif.DIMENSION_ID))
                        self.ReportDimensionSet.DimensionSelectors.push(new WorkspaceBOIWorkspaceReportDimensionSelector(self.WorkspaceBO, aRptDimRow, parentDimRow ))
                    })

                    self._bIDimensionSelectorSetLoaded = true
                    resolve(selfDSS)
                })

                return self._IDimensionSelectorLoadPromise
            }

        }

        // Initiate the load processing
        let loadStart = self.ReportDimensionSet.OnIDimensionSelectorSetLoadComplete


    }

    get WorkspaceReportId(): number {
        return this.WorkspaceReportRow.cif.WB_WORKSPACE_RPTL_ID
    }

    get Report(): IReportTile {

        let rptRow = this.WorkspaceReportRow.WB_ReportRow
        let returnValue: IReportTile = {
            ReportId: rptRow.cif.REPORT_ID,
            ReportTypeId: rptRow.cif.REPORT_TYPE_ID,
            ReportName: rptRow.cif.REPORT_NAME,
            ReportDescription: rptRow.cif.REPORT_DESCRIPTION,
            ReportRenderOptions: JSONUtils.parse(rptRow.cif.RENDER_OPTIONS, {}),
            ReportHelpURL: rptRow.cif.REPORT_HELP_URL
        }
        return returnValue
    }

    get Connection(): IConnection {
        let cnxRow = this.WorkspaceReportRow.WB_ReportRow.WB_ConnectionRow

        let returnValue: IConnection = {
            ConnectionId: cnxRow.cif.CONNECTION_ID,
            ConnectionTypeId: cnxRow.cif.CONNECTION_TYPE_ID,
            ConnectionName: cnxRow.cif.CONNECTION_NAME,
            ConnectionOptions: JSONUtils.parse(cnxRow.cif.CONNECTION_OPTIONS, {})
        }

        return returnValue

    }

    get DimensionSelectorGroup(): IDimensionSelectorSet {
        return this.ReportDimensionSet
    }


    //</editor-fold>

    saveState() {

        // Save Dimension Selections
        _.forEach(this.ReportDimensionSet.DimensionSelectors, (aDimensionSelector: WorkspaceBOIWorkspaceReportDimensionSelector) => {
            aDimensionSelector.saveSelections()
        })

        // Save Position/ Width
        let renderOptions: { [id: string]: any } = this.ElementRenderer.getRenderOptions()

        this.WorkspaceReportRow.cif.RENDER_OPTIONS = JSON.stringify(renderOptions)
    }

}
